/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { riskCategoriesList } from "../funcs/riskCategoriesList.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { RiskCategoriesResult } from "../models/components/riskcategoriesresult.js";
import {
  ListRiskCategoriesRequest,
  ListRiskCategoriesSecurity,
} from "../models/operations/listriskcategories.js";
import { unwrapAsync } from "../types/fp.js";

export class Categories extends ClientSDK {
  /**
   * listRiskCategories risk
   *
   * @remarks
   * Return the canonical risk category definitions: metadata (label/description/icon) plus the classification (source / rule_id list / rule_id prefix) used to bucket findings. Dashboards and CLIs should call this instead of maintaining their own copy of the mapping.
   */
  async list(
    request?: ListRiskCategoriesRequest | undefined,
    security?: ListRiskCategoriesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskCategoriesResult> {
    return unwrapAsync(riskCategoriesList(
      this,
      request,
      security,
      options,
    ));
  }
}
